import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { OrganizationSettingsPanel } from '~/features/settings/OrganizationSettingsPanel';

// Settings → Organization (the section index). The org + role this panel reads are
// already warmed by the `_protected` loader, so no per-route loader is needed.
export const Route = createFileRoute('/_protected/settings/')({
  component: SettingsIndexRoute,
});

function SettingsIndexRoute(): ReactNode {
  return <OrganizationSettingsPanel />;
}
